import React, { createContext } from 'react';

const CoreContext = createContext();

export default CoreContext;
